import * as Yup from 'yup';

import { Box, Flex, Spacer, Stack } from '@chakra-ui/react';
import { FormHandles, SubmitHandler } from '@unform/core';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { LinkText, PageSignWrapper, SignTitle, SignWrapper } from 'custom-style-components';
import { People, PeopleAPIModel } from 'types/models';
import React, { useRef, useState } from 'react';

import { BR } from './styled';
import COLORS from 'constants/COLORS';
import { CancelToken } from 'axios';
import CustomButton from 'components/Button';
import { Form } from '@unform/web';
import { GenericFrontError } from 'errors/GenericFrontError';
import Input from 'components/Input';
import InputMask from 'components/InputMask';
import Navbar from 'components/Navbar';
import { ResponseError } from 'errors/ResponseError';
import TOAST from 'constants/TOAST';
import { api } from 'services/axios';
import createCancelTokenSource from 'utils/createCancelTokenSource';
import getValidationError from 'utils/getValidationErrors';
import mapPeopleFromAPI from 'utils/mapFunctions/mapPeople';
import { useToast } from '@chakra-ui/toast';

interface FormData {
    email: string;
    password: string;
    cpf: string;
}

function useQuery() {
    return new URLSearchParams(useLocation().search);
}


const RequestPasswordRecover: React.FC = () => {
    const toast = useToast({
        duration: TOAST.DURATION,
        position: TOAST.DEFAULT_POSITION,
        isClosable: TOAST.CLOSABLE_BY_DEFAULT,
    });

    const [error, setError] = useState<string>();

    const formRef = useRef<FormHandles>(null);

    const [submitLoading, setSubmitLoading] = useState(false);

    const history = useHistory();

    const onSubmit: SubmitHandler<FormData> = async (data) => {
        setSubmitLoading(true);
        const source = createCancelTokenSource();
        try {
            formRef.current?.setErrors({});

            const schema = Yup.object().shape({
                email: Yup.string()
                    .required('E-mail obrigatório')
                    .email('Digite um e-mail válido'),
                cpf: Yup.string()
                    .required('CPF obrigatório')
                    .length(14, 'Formato inadequado'),
            });

            await schema.validate(data, {
                abortEarly: false,
            });

            // Limpa o CPF para comparar com o formato esperado
            const newCpf = data.cpf.replace(/\D/g, '');

            await api.post('/recover', {
                email: data.email,
                cpf: newCpf
            });


            toast({
                title: 'Uma nova senha será enviada, verifique a caixa de spam.',
                status: 'success'
            });

            history.push('/');


        } catch (err) {

            if (err instanceof Yup.ValidationError) {
                const errors = getValidationError(err);

                formRef.current?.setErrors(errors);
                return;
            }
            let message = '';

            if (err instanceof ResponseError) {
                if (err.status === 400) message = 'Ocorreu um erro desconhecido, por favor contate os administradores';
                if (err.status === 404) message = 'Dados incorretos';
            }
            toast({
                title: message,
                status: 'error',
            });

        } finally {
            setSubmitLoading(false);
        }
    };


    return (
        <>
            <Navbar />
            <PageSignWrapper>
                <SignTitle>Recuperar Senha</SignTitle>
                <SignWrapper>
                    <Form ref={formRef} onSubmit={onSubmit}>
                        <Stack spacing={4}>
                            <InputMask
                                name="cpf"
                                mask="cpf"
                                maxLength={14}
                                className="head"
                                placeholder="CPF no formato 999.999.999-99"
                            />
                            <Input
                                type="email"
                                name="email"
                                maxLength={100}
                                placeholder="exemplo@email.com"
                            />
                            <Flex>
                                <Spacer />
                                <Box>
                                    <CustomButton
                                        disabled={submitLoading}
                                        type="submit"
                                        style={{ backgroundColor: COLORS.success }}
                                    >
                                        Enviar e-mail
                                    </CustomButton>
                                </Box>
                            </Flex>
                        </Stack>
                    </Form>
                    <Stack spacing={2}>
                        <LinkText>
                            <Link className="open" to="/login">
                                Voltar para o login
                            </Link>
                        </LinkText>
                        <LinkText>
                            <Link className="open" to="/cadastrar">
                                Não possui conta? Cadastre-se!
                            </Link>
                        </LinkText>
                    </Stack>

                    <BR />
                    <hr />
                </SignWrapper>
            </PageSignWrapper>
        </>
    );
};

const RecoverPassword: React.FC = () => {
    const query = useQuery();

    const token = query.get('token');
    console.log(token);
    //token está sempre null, nunca vai cair na opção SendPassword
    //if (token) {
    //    return (<SendPassword />);
    //} else {
    return (<RequestPasswordRecover />);
    //}
};


export default RecoverPassword;
